/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

/**
 * ContentDescription displays the description for an episode, movie, or series.
 * If no description is available, nothing is rendered.
 * @param description - The content description string.
 * @param className - Optional CSS class for custom styling.
 * @returns The rendered content description component.
 */
const ContentDescription: FunctionComponent<{
    description?: string;
    className?: string;
}> = ({ description = '', className: aClassName = '' }) => {
    if (!description || description.length === 0) return null;
    const defaultClassName = 'primary-text-style text-light primary-margin-top';

    return (
        <React.Fragment>
            <div className={`uikit ${aClassName || defaultClassName}`}>{description}</div>
        </React.Fragment>
    );
};

export default ContentDescription;
